export const USER = {
    SHOW_MODAL: 'USER_SHOW_MODAL',
    CLOSE_MODAL: 'USER_CLOSE_MODAL',
    FETCH_USER_LIST: 'FETCH_USER_LIST',
    ON_USER_LIST_FETCHED: 'ON_USER_LIST_FETCHED',
    ON_USER_UPDATED: 'ON_USER_UPDATED',
    ON_FAILED: 'ON_FAILED'
};
